import axiosClient from "./axiosClient.js";

const tagApi = {
  getByShopId: (shopId) => {
    const url = `/tags/getByShopId/${shopId}`;
    return axiosClient.post(url);
  },
  getByAccountId: (accountId) => {
    const url = `/tags/getByAccountId/${accountId}`;
    return axiosClient.get(url);
  },
  getZaloTagsByAccountId: (accountId) => {
    const url = `/tags/zalo/getByAccountId/${accountId}`;
    return axiosClient.get(url);
  },
  create: (data) => {
    const url = `/tags/create`;
    return axiosClient.post(url, data);
  },
  updateByIds: (data) => {
    const url = `/tags/updateByIds`;
    return axiosClient.put(url, data);
  },
};

export default tagApi;
